import { ApiLoadingState } from '../../../middleware/api/apiList'
import { lineItems } from '../InvoiceReport/yearlyInvoiceAudittype'

export type GetClientInvoiceAudit = {
  result: result[]
  displayStartDate: string
  displayEndDate: string
}

export type GetAllResults = {
  result: result[]
}

export type result = {
  key: null
  monthName: null
  year: null
  invoiceAmountTotal: number
  finalAmountTotal: number
  receivedAmountTotal: number
  balanceAmountTotal: number
  totalTaxAmount: number
  invoiceStatus: string
  tdsAmountTotal: number
  netAmountTotal: number
  auditDtos: []
  clientName: string
  clientId: number
  projectId: null | number
  projectName: null | string
}

export type InvoiceAuditProps = {
  fromDate: string
  multiText: null | string
  pendingAmountFlag: boolean
  selectionStatus: string
  toDate: string
}
export type clients = {
  id: number
  clientCode: null
  name: null
  address: null
  personName: null
  email: null
  country: null
  phone: null
  description: null
  organization: null
  totalFixedBids: number
  totalRetainers: number
  clientStatus: boolean
  gstCode: null
}
export type ClientInvoiceReportState = {
  clientInvoiceAudit: GetClientInvoiceAudit
  isLoading: ApiLoadingState
  clients: clients[]
  selectedClientStatus: ClientStatus
  ProjectInvoiceDetails: clientResults[]
  result: result[]
  inVoiceSummary: inVoiceSummary
}

export enum ClientStatus {
  'all' = 'All',
  'active' = 'Active',
  'inactive' = 'InActive',
}
export type ProjectAuditProps = {
  clientId: number
  displayEndDate: string
  displayStartDate: string
  pendingAmountFlag: boolean
}

export type ClientsProjectInvoicesAuditProps = {
  projectId: number
  displayEndDate: string
  displayStartDate: string
  pendingAmountFlag: boolean
}

export type ProjectInvoiceDetails = {
  result: clientResults[]
}
export type TaxDto = {
  id: number
  taxType: string
  taxRate: string
  tax: string
}
export type amountDTOs = {
  id: number
  receivedAmount: string
  receivedDate: string
  tdsAmount: null
  netAmount: string
}

export type clientResults = {
  id: number
  number: string
  clientname: string
  projectName: string
  invoiceDuration: null
  invoiceCount: null
  invoiceRate: null
  country: string
  bankName: null
  currencyType: string
  wireTransferInstructions: null
  notes: null
  discountType: null
  discountRate: null
  discount: null
  taxType: null
  taxRate: null
  tax: null
  paymentTerm: null
  invoiceDate: null
  dueDate: null
  invoiceAmountReceviedDate: string
  invoiceStatus: string
  subTotal: string
  amount: string
  totalAmount: string
  finalAmount: string
  amountAfterDiscount: null
  lineitems: null
  taxDTOs: TaxDto[]
  amountDTOs: amountDTOs[]
  invoiceId: number
  modifiedDate: null
  modifiedBy: null
  persistType: null
  milestoneName: null
  projectManager: string
  projectType: string
  projectStatus: string
  invoiceSentDate: string
  statusNotes: null
  adjustedInvoice: null
  rate: number
  conversionRate: null
  receivedAmount: string
  balanceAmount: string
  invoiceNumberFlag: null
  invoiceNumber: string
  invoicePattern: null
  invoiceReferenceNumber: null
  totalTaxAmount: number
  tdsAmount: string
  netAmount: string
  clientCountry: string
  modifiedMilestoneName: null
  proformaInvoiceFlag: boolean
  proformaReferenceNo: null
  saltKey: null
}

export type remittanceTypeDetails = {
  id: number
  bankName: string
  currencyType: string
  location: string
  wireTransferInstructions: string
  clientName: string
  client: number
}

export type receivedAmountList = {
  id: number
  receivedAmount: string
  receivedDate: string
  tdsAmount: null
  netAmount: string
}

export type inVoiceSummary = {
  id: number
  projectId: number
  projectName: string
  projectType: string
  clientId: number
  client: string
  clientContactPerson: string
  number: string
  referenceNumber: string
  pattern: string
  notes: string
  showNotesOnInvoice: false
  subTotal: string
  amount: string
  totalAmount: string
  paymentTerm: string
  invoiceDate: string
  dueDate: string
  invoiceAmountReceviedDate: string
  invoiceStatus: string
  remittance: remittanceTypeDetails
  lineitem: lineItems[]
  milestoneId: number
  discountType: null
  milestoneDTOs: null
  discountRate: string
  discount: string
  taxType: null
  taxRate: null
  tax: null
  country: string
  mileStoneName: string
  milestonePercentage: string
  companyAdress: string
  currencyType: string
  numberInWords: string
  organization: string
  taxDTO: TaxDto[]
  genarateType: null
  eachDay: null
  invoiceDuration: null
  invoiceCount: null
  invoiceRate: null
  roleAndNameCount: []
  resourcesName: []
  countTypeToDisplay: null
  amountAfterDiscount: string
  percentage: string
  invoiceAmountSentDate: string
  poNumber: null
  statusNotes: string
  writeoffAmount: string
  receivedAmount: string
  totalReceivedAmount: string
  receivedAmountList: receivedAmountList[]
  invoiceUpdatable: boolean
  invoiceMutable: boolean
  invoiceStatusList: string[]
  isAdjusted: null
  canBeAdjusted: boolean
  showCanBeAdjusted: boolean
  showRestrictAdjusting: boolean
  showTaxDetailsOnInvoice: null
  companyAddress: string
  companyName: string
  conversionRate: null
  gstCode: null
  invoiceNumberFlag: null
  crid: null
  crduration: null
  billingContactPerson: null
  billingContactPersonEmail: null
  invoiceNumber: string
  invoicePattern: string
  invoiceReferenceNumber: string
  tdsAmount: null
  netAmount: string
  clientCountry: string
  modifiedMilestoneName: null
  milestoneTypeFlag: string
  proformaInvoiceFlag: boolean
  proformaReferenceNo: null
  discountDTO: null
}
